export default "__VITE_ASSET__FFWPDrWJ__"